<template>
  <div>
    <h2 class="automations-title">
      <font-awesome-icon
        :icon="['fad', 'sparkles']"
        class="mr-2"
      ></font-awesome-icon>
      {{ $tc('automations.automations', 2) }}
    </h2>
    <div>
      <h2 class="automations-attirbutes-title mt-3">
        <font-awesome-icon
          :icon="['fad', 'database']"
          class="mr-2"
        ></font-awesome-icon>
        {{ $tc('automations.knowledge-base', 2) }}
      </h2>
      <div v-for="knowledge in knowledges" :key="knowledge.id" class="mb-2">
        <AutomationKnowledgeMenu
          :knowledge="knowledge"
          :collapse="focusedKnowledgeId === knowledge.id"
          @updateFocusedKnowledge="updateFocusedKnowledge"
          @updateFocusedCase="$emit('updateFocusedCase', $event)"
        ></AutomationKnowledgeMenu>
      </div>
    </div>

    <div class="mt-4">
      <h2 class="automations-attirbutes-title">
        <font-awesome-icon
          :icon="['fad', 'user-robot']"
          class="mr-2"
        ></font-awesome-icon>
        {{ $tc('automations.attributes', 2) }}
      </h2>
      <div
        v-for="integration in integrations"
        :key="integration.value"
        class="mb-2"
      >
        <AutomationIntegrationAttributesMenu
          :title="integration.title"
          :attributes="integration.attributes"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AutomationKnowledgeMenu from './AutomationKnowledgeMenu';
import AutomationIntegrationAttributesMenu from './AutomationIntegrationAttributesMenu';

const INTEGRATIONS = ['zendesk', 'intercom', 'salesforce', 'salesforce_2'];

export default {
  name: 'AutomationsMenu',
  components: {
    AutomationKnowledgeMenu,
    AutomationIntegrationAttributesMenu,
  },
  props: {
    knowledges: {
      type: Array,
      default: () => [''],
    },
    groupedAttributes: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedContent: '',
      focusedKnowledgeId: null,
    };
  },
  computed: {
    hasMultiSalesforce() {
      return !!this.getCompanyPreference('HAS_MULTI_SALESFORCE_ACCOUNT');
    },
    integrations() {
      let integrations = INTEGRATIONS;
      if (!this.hasMultiSalesforce)
        integrations = integrations.filter((el) => el !== 'salesforce_2');
      return integrations
        .map((i) => {
          if (!this.groupedAttributes[i]) return null;
          return {
            title: i.toUpperCase(),
            attributes: this.groupedAttributes[i],
          };
        })
        .filter((el) => !!el);
    },
    ...mapGetters(['getCompanyPreference']),
  },
  methods: {
    updateFocusedKnowledge(event) {
      const { knowledgeId } = event;
      if (this.focusedKnowledgeId === knowledgeId) {
        this.focusedKnowledgeId = null;
      } else {
        this.focusedKnowledgeId = knowledgeId;
        this.$emit('updateFocusedKnowledge', event);
      }
    },
    updateFocus(knowledgeId) {
      this.$emit('changeFocus', {
        id: this.selectedContent,
        label: this.getRootLabel,
        knowledgeId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.automations-title {
  color: $blue-mayday;
}
.automations-attirbutes-title {
  color: $grey-5-mayday;
}
</style>
